// src/components/student/ExamTimer.jsx
// Countdown for timed "Exam mode" quizzes. Counts down from `durationMins` and
// fires onExpire() once when it hits zero. Pure setInterval — no dependencies.
import React, { useEffect, useRef, useState } from "react";
import { HiClock } from "react-icons/hi";

export default function ExamTimer({ durationMins, paused = false, onExpire }) {
  const [remaining, setRemaining] = useState(Math.max(0, Math.round(durationMins * 60)));
  const firedRef = useRef(false);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (paused) return undefined;
    const t = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(t);
          if (!firedRef.current) {
            firedRef.current = true;
            // Defer so we don't setState in another component during render.
            setTimeout(() => onExpireRef.current && onExpireRef.current(), 0);
          }
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [paused]);

  const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
  const ss = String(remaining % 60).padStart(2, "0");

  const tone =
    remaining <= 30
      ? "bg-red-100 text-red-700 border-red-200 animate-pulse"
      : remaining <= 120
      ? "bg-amber-100 text-amber-700 border-amber-200"
      : "bg-slate-100 text-slate-700 border-slate-200";

  return (
    <span
      className={`flex-shrink-0 inline-flex items-center gap-1.5 border font-mono font-bold text-sm px-3 py-1.5 rounded-xl tabular-nums ${tone}`}
      aria-label="Time remaining"
      title="Time remaining"
    >
      <HiClock className="text-base" />
      {mm}:{ss}
    </span>
  );
}
